import { useEffect, useRef, useState, useContext } from "react";
import { useLocation, useSearchParams } from "react-router-dom";


import { offerwallapi } from "../../config/axiosconfig";
import { ClientContext } from "../../context/client/ClientContext";
import { TenantContext } from "../../context/tenant/TenantContext";
import CryptoJS from "crypto-js";
import { LanguageContext } from "../../context/language/LanguageContext";
// import { encode, encodeURL } from 'js-base64';
import { Link, useNavigate } from "react-router-dom";

import "./pagenotfound.css";
import { CardContext } from "../../context/card/CardContext";
import { Spinner } from "react-bootstrap";
import Cookies from "universal-cookie";
import { CLOUDFRONT, ENROLL_REDIRECT_URL } from "../../utils/env";


export default function PageNotFound() {
    //?info={
    // CID:efd952b5-681c-ef11-b3e4-b8cef6052529,
    // EUID:42a4f71dca6414d6d802809ef0ed38508a3e6c4c,
    // SUCCESS:true,
    // UID:ed3e7f51-ef93-4971-adff-85581b186d8a
    // }
    const cookies = new Cookies();
    const url = useLocation().search;//.pathname.split("/");
    // console.log("A", url)
    const [searchParams, setSearchParams] = useSearchParams();
    // console.log("A", searchParams.get("info"))


    // const urlPath = url[1];
    useEffect(() => {

        window.top.postMessage(window.location.href, "*");

        // Always set visa-japan favicon on this page
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = `${CLOUDFRONT}favicons/visa-japan.ico`;

        if (searchParams.get("info")) {
            document.title = "VISA - Japan";
        }
        // CardAddProcess();

    }, []);




    const navigate = useNavigate();
    const { tenant, tenantdispatch } = useContext(TenantContext);
    const { client, clientdispatch } = useContext(ClientContext);
    const { language, languagedispatch } = useContext(LanguageContext);
    const { card, carddispatch } = useContext(CardContext);


    // const [showConfirmModal, setShowConfirmModal] = useState(false);
    // const [showEmailSubscriptionConfirmModal, setShowEmailSubscriptionConfirmModal] = useState(false);
    // const [confirmMessage, setConfirmMessage] = useState("");
    // const [confirmType, setConfirmType] = useState("");
    // const [isDisabled, setIsDisabled] = useState(true);
    // const [visaParams, setVisaParams] = useState({});
    // const [rsaEncryptedVals, setRSAEncryptedVals] = useState();

    // const [cardList, setCardList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [message, setMessage] = useState("");
    const [langConts, setLangConts] = useState();
    const [tenantObj, setTenantObj] = useState();
    const [countdown, setCountdown] = useState(5);
    const [showGeneric404, setShowGeneric404] = useState(false);

    // const [selectedCard, setSelectedCard] = useState({});
    // const [eventExists, setEventExist] = useState(false);
    // const [expressURL, setExpressURL] = useState("");
    // const [isLoaded, setIsLoaded] = useState(false);
    // const txtVisaCardNumber = useRef();
    // const ifrmMini = useRef();
    // const chkEmailSubscription = useRef();


    useEffect(() => {

        // Wait for client to be available before redirecting (handles cookie timing after cross-domain redirect)
        if (client && client.tenanturlname) {
            // Set favicon based on tenant
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.getElementsByTagName('head')[0].appendChild(link);
            }
            const cdnFavicon = `${CLOUDFRONT}favicons/${client.tenanturlname}.ico`;
            const img = new Image();
            img.onload = () => { link.href = cdnFavicon; };
            img.onerror = () => { link.href = `${CLOUDFRONT}favicons/visa-japan.ico`; };
            img.src = cdnFavicon;

            if (searchParams.get("info")) {
                if (!ENROLL_REDIRECT_URL) {
                    window.location.href = `/${client.tenanturlname}/myprofile?info=${searchParams.get("info")}`;
                } else {
                    window.location.href = `${ENROLL_REDIRECT_URL}/${client.tenanturlname}/myprofile?info=${searchParams.get("info")}`;
                }
            } else {
                if (!ENROLL_REDIRECT_URL) {
                    window.location.href = "https://www.visa.com";
                } else {
                    window.location.href = ENROLL_REDIRECT_URL;
                }
            }
        } else if (!client) {
            // Client still loading, wait for it
            console.log('PageNotFound - Waiting for client to load...');
        } else {
            // No client found and no ?info= parameter - show generic 404
            if (!searchParams.get("info")) {
                setShowGeneric404(true);
            }
        }

    }, [client]);// eslint-disable-line react-hooks/exhaustive-deps

    // Countdown timer for generic 404
    useEffect(() => {
        if (showGeneric404 && countdown > 0) {
            const timer = setTimeout(() => {
                setCountdown(countdown - 1);
            }, 1000);
            return () => clearTimeout(timer);
        } else if (showGeneric404 && countdown === 0) {
            if (!ENROLL_REDIRECT_URL) {
                window.location.href = "https://www.visa.com";
            } else {
                window.location.href = ENROLL_REDIRECT_URL;
            }
        }
    }, [showGeneric404, countdown]);

    const getTenant = async (lanid) => {

        // const owclient = cookies.get("ow-c");
        // setTenantObj(owclient);
        tenantdispatch({ type: "TENANT_START" });
        try {
            const res = await offerwallapi.get("/api/tenants/tenantgetbyurlname", {
                params: {
                    tenanturlname: client.tenanturlname,
                    languageid: lanid
                }
            });
            if (res.data.length === 0) navigate("/");

            // console.log(res.data)
            const tenantobj = res.data


            await localStorage.setItem("l", JSON.stringify({ languageid: tenantobj.languageid, languagecode: tenantobj.languagecode }));

            // res.data.tenantmasterconfig = JSON.parse(res.data.tenantmasterconfig)
            // res.data.tenantcontentconfig = JSON.parse(res.data.tenantcontentconfig)


            tenantdispatch({ type: "TENANT_SUCCESS", payload: res.data });

            // document.title = res.data.tenantmasterconfig.title;


            return { languageid: tenantobj.languageid, languagecode: tenantobj.languagecode }

        } catch (err) {
            tenantdispatch({ type: "TENANT_FAIL", payload: err });
        }
    }

    const getLanguage = async (lanid, lancode) => {


        const { languageid, languagecode } = await getTenant(lanid);
        try {
            languagedispatch({ type: "LANGUAGE_START" });
            const res = await offerwallapi.get("/api/public/multilingual/" + languageid);

            languagedispatch({ type: "LANGUAGE_SUCCESS", payload: JSON.parse(res.data.languagecontent) });
            setLangConts(JSON.parse(res.data.languagecontent));
            CardAddProcess(JSON.parse(res.data.languagecontent));
        } catch (err) {
            languagedispatch({ type: "LANGUAGE_FAIL", payload: err });
        }
        // if (client && client.defaultlanguageid !== languageid) updateClientLanguage(languageid, languagecode);
    }


    const CardAddProcess = async (lancon) => {
        if (searchParams.get("info")) {

            setMessage("");
            setLoader(true);
            // console.log("CARD ADD PROCESS")
            // const encryptparams = await GetVisaParams();

            // const info = `{EUID:${client.externaluserid},PC:${tenant.tenantpromocode},EM:${encryptparams.email}}`;

            // const key = CryptoJS.enc.Utf8.parse(encryptparams.visa_key);
            // const iv = CryptoJS.enc.Utf8.parse(encryptparams.visa_iv);

            // const encryptedInfo = CryptoJS.AES.encrypt(info, key, {
            //     iv: iv,
            //     mode: CryptoJS.mode.CBC,
            //     padding: CryptoJS.pad.Pkcs7,
            // }).toString();

            const returnparams = searchParams.get("info").replace("{", "").replace("}", "");
            // {CID:425e6472-9c44-e511-a87a-4851b7b88ee9,SUCCESS:true,UID:8bb0366b-ca89-4339-a900-521ee1e82398}
            const cid = returnparams.split(",")[0].replace("CID:", "");
            const euid = returnparams.split(",")[1].replace("EUID:", "");
            const success = returnparams.split(",")[2].replace("SUCCESS:", "");
            const uid = returnparams.split(",")[3].replace("UID:", "");


            const errorcode = returnparams.split(",")[3].replace("UID:", "");
            const errormessage = returnparams.split(",")[3].replace("UID:", "");

            //https://www.stg.offers-exchange.com/?info={
            //     ERRCODE:Invalid_EnrollmentEligibility,
            //     ERRMSG:Invalid_EnrollmentEligibility,
            //     EUID:42a4f71dca6414d6d802809ef0ed38508a3e6c4c,
            //     SUCCESS:false
            // }
            const newcards = await getCards()

            let cardExist = false;
            if (newcards) {
                for (let i = 0, j = newcards.length; i < j; i++) {
                    if (cid === newcards[i].cardnumber) {
                        cardExist = true;
                        break;
                    }
                }
            }

            if (!cardExist) {
                // console.log("CARD ADD PROCESS - CARD NOT EXIST")
                // console.log("SUCCESS : ", success)
                if (success === "true") {
                    // console.log("CARD ADD PROCESS - VISA ENROLLMENT SUCCESS")
                    try {
                        const userdata = await offerwallapi.post("/api/cards/getvisacarduser", {
                            tenantid: client.tenantid,
                            clientid: client.clientid,
                            userkey: client.externaluserid
                        });

                        try {
                            //const clientobj = { ...client }
                            //clientobj.visaclientid = uid;
                            //clientobj.isenrolled = 1;
                            //clientdispatch({ type: "CLIENT_SUCCESS", payload: clientobj });
                            const cardobj = {};
                            const carddetails = userdata.data.enrollmentRecord.cardDetails;
                            cardobj.isdefault = (carddetails.length === 1) ? 1 : 0;
                            cardobj.clientid = client.clientid;
                            cardobj.tenantid = client.tenantid;
                            //tenant.tenantid;
                            cardobj.UserKey = client.externaluserid;
                            cardobj.UserId = uid;
                            cardobj.CardId = cid;

                            for (let i = 0, j = carddetails.length; i < j; i++) {
                                if (cid === carddetails[i].CardId) {
                                    cardobj.ReferenceId = carddetails[i].ServiceKey;
                                    cardobj.CardLast4 = carddetails[i].CardLast4;
                                    break;
                                }
                            }
                            // console.log("CARD ADD PROCESS - CARD OBJECT : ", cardobj)
                            const clientobject = await offerwallapi.post("/api/cards/cardcreate", cardobj);

                            //clientdispatch({ type: "CLIENT_SUCCESS", payload: clientobject });
                            // console.log("CARD ADD PROCESS - CARD ADDED OT OW")
                            // setExpressURL(`${encryptparams.expressmini_url}${encryptparams.community_code}?info=${encodeURIComponent(encryptedInfo)}&info1=${encodeURIComponent(encryptparams.visa_info1_express)}&info2=V${encryptparams.cert_version}`);
                            // console.log("CARD ADD PROCESS - SUCCESS : ", language?.success_res.success_l4)
                            clientdispatch({ type: "CLIENT_SUCCESS", payload: clientobject.data });
                            setMessage(lancon?.success_res.success_l4);
                            setTimeout(() => {
                                setLoader(false)
                                window.location.href = `/${client.tenanturlname}/user/mycards`;
                            }, 2000);

                            //getCards();

                        } catch (err) {
                            console.log("OW-ERR-ADDCARD 1: ", err)
                            // setExpressURL(`${encryptparams.expressmini_url}${encryptparams.community_code}?info=${encodeURIComponent(encryptedInfo)}&info1=${encodeURIComponent(encryptparams.visa_info1_express)}&info2=V${encryptparams.cert_version}`);

                            setMessage(lancon?.error_res.error_l10);
                            setTimeout(() => {
                                setLoader(false)
                                window.location.href = `/${client.tenanturlname}/user/mycards`;
                            }, 2000);
                        }
                    } catch (err) {
                        console.log("OW-ERR-ADDCARD 2: ", err)
                        // setExpressURL(`${encryptparams.expressmini_url}${encryptparams.community_code}?info=${encodeURIComponent(encryptedInfo)}&info1=${encodeURIComponent(encryptparams.visa_info1_express)}&info2=V${encryptparams.cert_version}`);

                        setMessage(lancon?.error_res.error_l10);
                        setTimeout(() => {
                            setLoader(false)
                            window.location.href = `/${client.tenanturlname}/user/mycards`;
                        }, 2000);
                    }


                } else {
                    // console.log("MINIXPRESS-ERR-ADDCARD : ", returnparams)
                    // setExpressURL(`${encryptparams.expressmini_url}${encryptparams.community_code}?info=${encodeURIComponent(encryptedInfo)}&info1=${encodeURIComponent(encryptparams.visa_info1_express)}&info2=V${encryptparams.cert_version}`);
                    setMessage(lancon?.error_res.error_l10);
                    setTimeout(() => {
                        setLoader(false)
                        window.location.href = `/${client.tenanturlname}/user/mycards`;
                    }, 2000);
                }
                //check for SUCCESS=TRUE to get CardId and UserId and perform exception handling otherwise, etc..
            } else {
                console.log("OW-ERR-CARDEXIST : ", cardExist)
                // setExpressURL(`${encryptparams.expressmini_url}${encryptparams.community_code}?info=${encodeURIComponent(encryptedInfo)}&info1=${encodeURIComponent(encryptparams.visa_info1_express)}&info2=V${encryptparams.cert_version}`);

                setMessage(lancon?.error_res.error_l15);
                setTimeout(() => {
                    setLoader(false)
                    window.location.href = `/${client.tenanturlname}/user/mycards`;
                }, 2000);
            }
            // window.addEventListener("message", CardAddProcess, false);
        }
    }

    // const GetVisaParams = async () => {
    //     const encryptparams = await offerwallapi.get("/api/cards/enrolleevisaparams", {
    //         params: {
    //             tenantid: 1004, 
    //             //tenant.tenantid,
    //             clientid: client.clientid
    //         }
    //     });
    //     return encryptparams.data;
    // }

    const getCards = async () => {
        try {
            carddispatch({ type: "CARD_START" });
            const cards = await offerwallapi.get("/api/cards/cardgetall", {
                params: {
                    clientid: client.clientid,
                    tenantid: client.tenantid
                    //tenant.tenantid
                }
            });
            carddispatch({ type: "CARD_SUCCESS", payload: cards.data });
            return cards.data; // setMyCards(cards.data);
        } catch (error) {
            console.log("OW-ERR-GETCARDS : ", error)
            carddispatch({ type: "CARD_FAIL", payload: error });
        }

        // setCardList(cards.data);
    }
    //process.env.REACT_APP_EXPRESSMINI_REDIRECT_URL
    return <div>
        {showGeneric404 ? (
            <div className="generic-404-container">
                <div className="generic-404-content">
                    <h1 className="generic-404-title">404</h1>
                    <p className="generic-404-message">Oops, we can't seem to find the page you are looking for</p>
                    <p className="generic-404-redirect">Redirecting in {countdown} seconds...</p>
                </div>
            </div>
        ) : (
            <>
                <h1 className="text-center">{(url === "") ?
                    <div className="welcome-page-text">
                        <span className="welcome-page-blue">Welcome to offers exchange</span>
                    </div>
                    : ""}</h1>

                {
                    (loader) ? <div className="ow-full-overlay">
                        <div className="position-absolute ow-content-center text-center">
                            <Spinner animation="border" backdrop="static" variant="light" />
                            <h3 className="text-light">{message}</h3>
                        </div>
                    </div>
                        : ""
                }
            </>
        )}
    </div>
}